import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
  },
  strict: process.env.DEV,


  state: {
    selectedCategory: '9999',
    selectedCategoryCd: '',
    selectedCISMenu: '',
    selectedAdminMenu: '',
    selectedVoteMenu: '',
    selectedTrkDspType: '',
    selectedTrkPrdType: '',
    selectedInsDspType: '',
    selectedStDate: '',
    selectedEnDate: '',
    selectedBrandInsightUpper: '',
    selectedTrendKeyword: '',
    aiAgentVisibility: false
  },
  mutations: {
    changeCategory (state, newSelectedCategory) {
      state.selectedCategory = newSelectedCategory
    },
    changeCategoryCd (state, newSelectedCategoryCd) {
      state.selectedCategoryCd = newSelectedCategoryCd
    },
    changeCISMenu (state, cisMenu) {
      state.selectedCISMenu = cisMenu
    },
    changeAdminMenu (state, adminMenu) {
      state.selectedAdminMenu = adminMenu
    },
    changeVoteMenu (state, voteMenu) {
      state.selectedVoteMenu = voteMenu
    },
    changeTrackingDisplayType (state, displayType) {
      state.selectedTrkDspType = displayType
    },
    changeTrackingPeriodType (state, periodType) {
      state.selectedTrkPrdType = periodType
    },
    changeInsightDisplayType (state, displayType) {
      state.selectedInsDspType = displayType
    },
    changePeriodSt (state, st_dt) {
      state.selectedStDate = st_dt
    },
    changePeriodEn (state, en_dt) {
      state.selectedEnDate = en_dt
    },
    changeBrandInsightUpper (state, selBrand) {
      state.selectedBrandInsightUpper = selBrand
    },
    changeTrendKeyword (state, selKeyword) {
      state.selectedTrendKeyword = selKeyword
    },
    changeAiAgentVisibility(state, visibility) {
      state.aiAgentVisibility = visibility
    }
  },
  actions: {
    callMutation ({ state, commit }, { newSelectedCategory }) {
      commit('changeCategory', newSelectedCategory)
    },
    callCategoryCd ({ state, commit }, { newSelectedCategoryCd }) {
      commit('changeCategoryCd', newSelectedCategoryCd)
    },
    callCISMenu ({ state, commit }, { cisMenu }) {
      commit('changeCISMenu', cisMenu)
    },
    callAdminMenu ({ state, commit }, { adminMenu }) {
      commit('changeAdminMenu', adminMenu)
    },
    callVoteMenu ({ state, commit }, { voteMenu }) {
      commit('changeVoteMenu', voteMenu)
    },
    callTrackingDisplayType ({ state, commit }, { displayType }) {
      commit('changeTrackingDisplayType', displayType)
    },
    callTrackingPeriodType ({ state, commit }, { periodType }) {
      commit('changeTrackingPeriodType', periodType)
    },
    callInsightDisplayType ({ state, commit }, { displayType }) {
      commit('changeInsightDisplayType', displayType)
    },
    callPeriodSt ({ state, commit }, { st_dt }) {
      commit('changePeriodSt', st_dt)
    },
    callPeriodEn ({ state, commit }, { en_dt }) {
      commit('changePeriodEn', en_dt)
    },
    callBrandInsightUpper ({ state, commit }, { selBrand }) {
      commit('changeBrandInsightUpper', selBrand)
    },
    callTrendKeyword ({ state, commit }, { selKeyword }) {
      commit('changeTrendKeyword', selKeyword)
    },
    callAiAgentVisibility ({ state, commit}, { visibility}) {
      commit('changeAiAgentVisibility', visibility)
    }
  },
  getters: {
    getSelectedCategory (state) {
      return `${state.selectedCategory}`
    },
    getSelectedCategoryCd (state) {
      return `${state.selectedCategoryCd}`
    },
    getSelectedCISMenu (state) {
      return `${state.selectedCISMenu}`
    },
    getSelectedAdminMenu (state) {
      return `${state.selectedAdminMenu}`
    },
    getSelectedVoteMenu (state) {
      return `${state.selectedVoteMenu}`
    },
    getSelectedTrackingDisplayType (state) {
      return `${state.selectedTrkDspType}`
    },
    getSelectedTrackingPeriodType (state) {
      return `${state.selectedTrkPrdType}`
    },
    getSelectedInsightDisplayType (state) {
      return `${state.selectedInsDspType}`
    },
    getSelectedPeriodSt (state) {
      return state.selectedStDate
    },
    getSelectedPeriodEn (state) {
      return state.selectedEnDate
    },
    getSelectedBrandInsightUpper (state) {
      return state.selectedBrandInsightUpper
    },
    getSelectedTrendKeyword (state) {
      return state.selectedTrendKeyword
    },
    getAiAgentVisibility(state) {
      return state.aiAgentVisibility
    }
  }
})



